import React from "react";

import { defaultSettings } from "./defaults/settings";
import Component from "./Component";
import Form from "./Form";

const createPlugin = (settings) => {
    const mergedSettings = { ...defaultSettings, ...settings };

    return {
        Component: (props) => <Component {...props} {...mergedSettings} />,
        FormComponent: (props) => <Form {...props} />,

        name: "russells/content/triple-hero",
        version: "1.0.0",
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            label: mergedSettings.defaultLabel,
            hero1Heading: "Hero 1",
            hero1ButtonLink: "",
            hero1Url: "",
            hero2Heading: "Hero 2",
            hero2ButtonLink: "",
            hero2Url: "",
            hero3Heading: "Hero 3",
            hero3ButtonLink: "",
            hero3Url: "",
        }),
    };
};

export default createPlugin;
